/**
 * @description Reporting v1 API client (paid-invoice + financial metrics).
 * @dependencies apiClient
 * @notes Amounts stay cents until display. GAAP endpoints stay on financialReportsService.
 */

import apiClient from './apiClient';

function unwrap(response) {
  return response.data?.data ?? response.data;
}

const reportingService = {
  getSalesSummary: async (params) => {
    const response = await apiClient.get('/reports/sales-summary', { params });
    return unwrap(response);
  },

  getSalesByPeriod: async (params) => {
    const response = await apiClient.get('/reports/sales-by-period', { params });
    return unwrap(response);
  },

  getSalesByProduct: async (params) => {
    const response = await apiClient.get('/reports/sales-by-product', { params });
    return unwrap(response);
  },

  getRevenueSplit: async (params) => {
    const response = await apiClient.get('/reports/revenue-split', { params });
    return unwrap(response);
  },

  getRecurringMetrics: async (params) => {
    const response = await apiClient.get('/reports/recurring-metrics', { params });
    return unwrap(response);
  }
};

export default reportingService;
